import styled from 'styled-components';
import Form from 'react-bootstrap/Form';

import { DeviceQueries } from './index';

export const StyledFormControl = styled(Form.Control)`
  &, &.disabled, &[readonly] {
    font-size: 16px;
    background-color: #fff;
    border: solid 1px #009bdf;
    height: 40px;
    -webkit-appearance: none;
    color: #000;
    padding: 0 24px;
  }

  @media (${DeviceQueries.mobile}) {
    padding: 0 10px;
  }
`;

// I tried solving this the same was as above, but styled-components are tricky about forwarding "as" attributes,
// and TypeScript compounded the solution to that problem.
export const StyledFormControlTextareaContainer = styled.div`
  textarea {
    font-size: 14px;
    background-color: #fff;
    border: solid 1px #009bdf;
    min-height: 40px !important;
    max-height: 100px !important;
    -webkit-appearance: none;
    color: #000;
    padding-left: 24px;
    padding-top: 8px;
  }
`;

